"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root = function root(theme, disabled) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("cursor:pointer;color:", theme.color.dark.copper, ";font-size:14px;padding:4px 0;&:hover{color:", theme.color.dark.silver, ";}", disabled && "\n    cursor: not-allowed;\n    color: ".concat(theme.color.grey1, ";\n    \n    &:hover {\n      color: ").concat(theme.color.grey1, ";\n    }\n  "))
  );
};

var _default = {
  root: root
};
exports.default = _default;